import {useCallback, useMemo} from 'react';
import {z as r} from 'zod';

import {useUser} from '../../provider/user/user-hook';
import {getFromLocalStorage, saveToLocalStorage} from '../../util/local-storage';

// "Все группы" — отсутствие фильтра по группе шаблонов
const ALL_GROUPS_ID = 0;

export const REVIEWS_TEMPLATE_GROUP_FILTER_STORAGE_KEY = 'reviews-response-template-group-filter';

// Запись per-user: { [userId]: folderId }. Изоляция фильтров между пользователями на одном устройстве.
const reviewsTemplateGroupFilterSchema = r.record(r.string(), r.number());

type ReviewsTemplateGroupFilterStorageType = Record<string, number>;

function getStorageData(): ReviewsTemplateGroupFilterStorageType {
    return getFromLocalStorage<ReviewsTemplateGroupFilterStorageType>(
        REVIEWS_TEMPLATE_GROUP_FILTER_STORAGE_KEY,
        reviewsTemplateGroupFilterSchema,
        {}
    );
}

export function getStoredGroupId(userId: number | null): number {
    if (userId === null) {
        return ALL_GROUPS_ID;
    }

    return getStorageData()[String(userId)] ?? ALL_GROUPS_ID;
}

export function setStoredGroupId(userId: number | null, groupId: number): void {
    if (userId === null) {
        return;
    }

    saveToLocalStorage<ReviewsTemplateGroupFilterStorageType>(
        {...getStorageData(), [String(userId)]: groupId},
        REVIEWS_TEMPLATE_GROUP_FILTER_STORAGE_KEY
    );
}

type ReviewTemplateGroupFilterHookType = {
    initialGroupId: number;
    persistGroupId: (groupId: number) => void;
};

export function useReviewTemplateGroupFilter(): ReviewTemplateGroupFilterHookType {
    const {user} = useUser();
    const userId = user?.id ?? null;

    const initialGroupId = useMemo(() => getStoredGroupId(userId), [userId]);
    const persistGroupId = useCallback((groupId: number) => setStoredGroupId(userId, groupId), [userId]);

    return {initialGroupId, persistGroupId};
}
